import React from 'react';
import * as S from './LabelWithLogo.style';
export const LabelWithLogo = ({ backgroundLogo, logo, value }) => (React.createElement(S.LabelWithLogo, null,
    React.createElement(S.LogoWrapper, { backgroundLogo: backgroundLogo },
        React.createElement(S.Logo, { src: logo, alt: "logo", width: "20", height: "20" })),
    React.createElement(S.Value, null, value)));
//# sourceMappingURL=LabelWithLogo.js.map